/* eslint-disable indent */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useContext, useEffect, useState } from 'react'
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import { Box, Container, Grid, Typography } from "@mui/material";

import Steps from "widgets/Steps/Steps";
import Footer from "widgets/Footer/Footer";
import { ApplicationFormContext } from 'app/providers/applicationForm/lib/ApplicationFormContext';
import { FormDataContext } from 'app/providers/formValues/lib/FormDataContext';
import {
	useCustomerJourneyMutationQuery,
	useJourneyQuery,
	useJourneyResultFormQuery
} from 'entities/ApplicationForm/hooks/queries';
import { useFormBackMutationQuery } from 'entities/ApplicationFormBack/hooks/queries';
import { useProcessMutationQuery } from 'entities/ApplicationProcess/hooks/queries';

import { NavigationBundle, NavigationContext } from 'app/providers/router/ui/NavigationContext';
import { UwQuestionsProvider } from 'app/providers/UwQuestionsProvider';
import ImageFromCDN from '../../features/LogoHeader/ui/LogoHeader';

const HomePage = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const { pathname } = location;
	const {
		setPolicyStartDate,
		setPolicyState,
		setSchemaAddress,
		formId,
	} = useContext(FormDataContext);
	const { setApplicationFormData } = useContext(ApplicationFormContext);
	const { isPending } = useCustomerJourneyMutationQuery();
	const { mutate: backButton, isSuccess: backSuccess } = useFormBackMutationQuery();
	const { mutate: getApplicationProcess} = useProcessMutationQuery();
	const mainQuery = useJourneyQuery()

	const journeyResultData = useJourneyResultFormQuery();
	const [back, setBack] = useState(false);
	const { from, to } = useContext<NavigationBundle>(NavigationContext);


	useEffect(() => {
		if (journeyResultData) {
			const policyStartDate = journeyResultData.quote_result.transactionDetails.policyEffectiveDate;
			const policyAddress = journeyResultData.property_address;

			if (policyStartDate) setPolicyStartDate(policyStartDate);
			if (policyAddress.state) {
				setPolicyState(policyAddress.state);
				setSchemaAddress({
					State: policyAddress.state,
					Address1: policyAddress.street1,
					Address2: policyAddress.street2,
					City: policyAddress.city,
					ZipCode: policyAddress.zip,
					FullAddress: '',
				});
			}
			setApplicationFormData(journeyResultData);
		}
	}, [journeyResultData, setApplicationFormData, setPolicyStartDate, setPolicyState, setSchemaAddress]);

	useEffect(() => {
		const applicationId = localStorage.getItem("client_id");
		if (backSuccess && applicationId && back) {
			getApplicationProcess(applicationId);
		}
	}, [backSuccess]);

	const goBack = () => {
		navigate(-1);
		setBack(true);
	}

	useEffect(() => {
		if (back) {
			if (formId) backButton(formId);
		}
	}, [back]);

	useEffect(() => {
		if (from?.pathname === "/checkout" && from.key !== "default" && to?.pathname === "/") {
			setBack(true);
		}
	}, [from, to]);

	useEffect(() => {
		if(mainQuery?.journeyStatus === 'issued') {
			window.location.href = 'https://renterscoverage.rein.ai/';
		}
	}, [mainQuery]);
	return (
		<Box >
			{journeyResultData && !isPending && (
				<>
					<Grid
						container
						spacing={0}
						sx={{ minHeight: '100vh' }}
					>
						<Grid size={12}>
							<Box sx={{ textAlign: 'center', position: 'relative' }} mt={5}>
								{pathname !== '/' && <Typography
									variant="body1"
									color={"primary.light"}
									fontSize={14}
									sx={{ mr: 1, cursor: 'pointer', position: 'absolute' }}
									onClick={goBack}
								>
									Back
								</Typography>}
								<ImageFromCDN />
							</Box>
							<Container maxWidth={"lg"} sx={{ mt: 5 }}>
								<UwQuestionsProvider data={journeyResultData.quote_result} customerData={journeyResultData}>
									<Steps/>
									<Outlet/>
								</UwQuestionsProvider>
								<Footer/>
							</Container>
						</Grid>
					</Grid>
				</>
			)}
		</Box>
	)
}

export default HomePage
